<template>
  <div>
    <b-modal id="modalIPtrafficService" ref="modalIPtrafficService" :title="$t('IP traffic service')" hide-footer size="xl" @shown="shown">
      <div v-if="editItem  && (serviceType === 3)">
        <b-tabs pills card vertical>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
              <b-form-input type="text" disabled v-model="editItem.service_data.parent_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_data.service_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="suppliertList" v-model="editItem.service_data.invoice_sup_id"/>
            </b-form-group>
            <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
              <b-form-checkbox v-model="editItem.service_data.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
              <b-form-checkbox v-model="editItem.service_data.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Service parameters')">
            <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" :disabled="editItem.service_data.links_count !== 0" v-model="editItem.periodic_service_data.cost" aria-describedby="inputFeedbackCost" :state="editItem.periodic_service_data.cost !== ''"/>
              <b-form-invalid-feedback id="inputFeedbackCost">
                {{ $t('Enter cost') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="chargeMethodList" v-model="editItem.periodic_service_data.charge_method"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="policyList" v-model="editItem.periodic_service_data.policy_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="schemeList" v-model="editItem.periodic_service_data.scheme_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="contractList" v-model="editItem.service_data.contract_type"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Traffic aggregation period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-row>
                <b-col cols="8">
                  <b-form-input type="number" v-model="editItem.iptraffic_service_data.aggregation_interval" :disabled="isDefault"/>
                </b-col>
                <b-col cols="4">
                  <b-form-checkbox v-model="isDefault">{{ $t('Default') }}</b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Limit of simultaneous sessions')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.periodic_service_data.radius_sessions_limit"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Reset prepaid traffic')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem.iptraffic_service_data.null_service_prepaid"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Dynamic IP address allocation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem.service_data.is_dynamic" value="1" unchecked-value="0"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Radius parameters')">
            <b-row>
              <b-col style="margin:5px">
                <md-button class="md-raised md-dense" @click="swohAddRadiusAttr">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Tariffication borders')">
            <b-row>
              <b-col style="margin:5px">
                <md-button class="md-raised md-dense" @click="showAddBorder">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="borderItemsFiltered" :fields="borderFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditBorderButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteBorder(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Groups')" v-if="prepaymentItems.length === 0">
            <b-form-group label-align="right" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="groupList" v-model="selectGroup" :disabled="borderItems.length > 0"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-row>
                <b-col>
                  <b-form-select :options="trafficClassesList" v-model="selectTrafficClassesFprGroup" :disabled="borderItems.length > 0"/>
                </b-col>
                <b-col>
                  <md-button class="md-raised" @click="addTrafficClass" :disabled="borderItems.length > 0">{{ $t('Add') }}</md-button>
                </b-col>
              </b-row>
            </b-form-group>
            <b-table small striped hover :items="groupItems" :fields="groupFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="deleteTrafficClass(row)" id="transparent" :disabled="borderItems.length > 0">
                  <b-img :src='deleteImage' style="width: 20px"/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Prepaid traffic')" v-if="groupItems.length === 0">
            <b-row>
              <b-col style="margin:5px">
                <md-button class="md-raised md-dense" @click="showAddPrepayment">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="prepaymentItems" :fields="prepaymentFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="ClickOnEditPrepaymentButton(row)" id="transparent">
                  <b-img :src='editImage' style="width: 20px"/>
                </b-button>
                <b-button size="sm" @click.stop="deletePrepayment(row)" id="transparent">
                  <b-img :src='deleteImage' style="width: 20px"/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="saveIPtrafficService" @cancel="$refs.modalIPtrafficService.hide" size="lg"/>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @edited="editRadiusAttr"
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Tariffication border')" ref="modalBorder">
      <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="trafficClassesList" v-model="selectTrafficClasses" :disabled="isEditBorder"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic volume')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="border.border" min="0"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="border.cost" min="0"/>
      </b-form-group>

      <modal-ok-cancel @save="saveBorder" @cancel="hideModalBorder" />
    </b-modal>

    <b-modal hide-footer :title="$t('Prepaid traffic')" ref="modalPrepayment">
      <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="trafficClassesList" v-model="selectTrafficClasses" :disabled="isEditPrepayment"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic volume')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="prepayment.prepaid_unit"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Accumulate no more than')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="prepayment.prepaid_unitMax"/>
      </b-form-group>
      <modal-ok-cancel @save="savePrepayment" @cancel="hideModalPrepayment" size="md"/>
    </b-modal>
  </div>
</template>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'
export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    serviceType: null,
    policyList: null,
    suppliertList: null,
    contractList: null,
    schemeList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      trafficClassesList: [],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      border: {
        'border': 0,
        'cost': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      emptyBorder: {
        'border': 0,
        'cost': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      prepayment: {
        'prepaid_unit': 0,
        'prepaid_unitMax': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      emptyPrepayment: {
        'prepaid_unit': 0,
        'prepaid_unitMax': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      maxGroup: [],
      maxGroupClass: {
        'tclass_id': 0,
        'value': 0,
        'text': this.$i18n.t('TClass from max group'),
        'tcclassName': this.$i18n.t('TClass from max group')
      },
      groupItems: [],
      groupFields: [
        {key: 'tcclassName', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEditPrepayment: false,
      prepaymentItems: [],
      prepaymentFields: [
        {key: 'tcclassName', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'prepaid_unit', label: this.$i18n.t('Traffic volume'), sortable: true},
        {key: 'prepaid_unitMax', label: this.$i18n.t('Accumulate no more than'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEditBorder: false,
      borderItems: [],
      borderFields: [
        {key: 'tcclassName', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'border', label: this.$i18n.t('Traffic volume'), sortable: true},
        {key: 'cost', label: this.$i18n.t('Cost per mbyte'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isDefault: true,
      selectTrafficClasses: 0,
      selectTrafficClassesFprGroup: 0,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      selectGroup: 1,
      groupList: [
        {text: 'max', value: 1},
        {text: 'sum', value: 2}
      ],
      editIPtrafficServices: null,
      radItemForEdit: null
    }
  },
  methods: {
    saveIPtrafficService () {
      if (!this.editItem.service_data.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.editItem.iptraffic_service_data.aggregation_interval === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Traffic aggregation fields is invalid'), 'Error')
        return
      }
      if (this.editItem.periodic_service_data.radius_sessions_limit === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Limit of simultaneous sessions fields is invalid'), 'Error')
        return
      }

      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.service_data.parent_id === 0) this.editItem.service_data.parent_id = -1
        this.editItem.service_data.link_by_default = Number(this.editItem.service_data.link_by_default)
        this.editItem.service_data.multiple_linking = Number(this.editItem.service_data.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      this.editItem.periodic_service_data.cost = Number(this.editItem.periodic_service_data.cost)
      this.editItem.service_data.is_dynamic = Number(this.editItem.service_data.is_dynamic)
      if (this.isDefault) {
        this.editItem.iptraffic_service_data.aggregation_interval = 0
      } else {
        this.editItem.iptraffic_service_data.aggregation_interval = Number(this.editItem.iptraffic_service_data.aggregation_interval)
      }
      this.editItem.periodic_service_data.radius_sessions_limit = Number(this.editItem.periodic_service_data.radius_sessions_limit)

      this.editItem.iptraffic_service_data.borders = this.borderItems
      if (this.groupItems.length > 0 && this.selectGroup === 1) {
        if (this.borderItems.length) {
          this.editItem.iptraffic_service_data.borders = []
          let borderItemsGroupMax = this.borderItems.filter((value) => {
            return value.tclass_id === 0
          })
          for (let i in borderItemsGroupMax) {
            for (let j in this.groupItems) {
              let newBorder = JSON.parse(JSON.stringify(borderItemsGroupMax[i]))
              newBorder.tclass_id = this.groupItems[j].tclass_id
              this.editItem.iptraffic_service_data.borders.push(newBorder)
            }
          }
          let borderItems = this.borderItems.filter((value) => {
            return value.tclass_id !== 0
          })
          for (let i in borderItems) {
            this.editItem.iptraffic_service_data.borders.push(borderItems[i])
          }
        }
      }
      for (let i in this.prepaymentItems) {
        this.prepaymentItems[i].size = this.prepaymentItems[i].prepaid_unit
        this.prepaymentItems[i].size_max = this.prepaymentItems[i].prepaid_unitMax
        this.prepaymentItems[i].tclass = this.prepaymentItems[i].tclass_id
      }
      this.editItem.iptraffic_service_data.prepaid = this.prepaymentItems
      for (let i in this.groupItems) {
        this.groupItems[i].group_id = this.selectGroup
      }
      this.editItem.iptraffic_service_data.tclass_id2group = this.groupItems
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_IP_TRAFFIC_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_IP_TRAFFIC_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalIPtrafficService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_data.service_id : response.data.service_id

          let invID = this.editItem.service_data.invoice_sup_id ? this.editItem.service_data.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          this.$store.dispatch('Tariffing/UPDATE_CHARGE_POLICY', {service_id: sid, policy_id: this.editItem.periodic_service_data.policy_id})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.service_data.multiple_linking ? this.editItem.service_data.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }

          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', {set_object_id: sid, set_type: 3, attrs: this.radiusAttrItems})
        }
      })
    },
    shown () {
      this.prepaymentItems = []
      this.groupItems = []
      this.borderItems = []
      this.trafficClassesList = []
      for (let el of this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']) {
        let newEl = {
          value: el.tclass_id,
          text: el.name + ' (' + el.tclass_id + ')'
        }
        this.trafficClassesList.push(newEl)
      }
      if (this.trafficClassesList.length > 0) {
        this.selectTrafficClassesFprGroup = this.trafficClassesList[0].value
        this.selectTrafficClasses = this.trafficClassesList[0].value
      }
      if (this.editItem.iptraffic_service_data.aggregation_interval) {
        this.isDefault = false
      } else {
        this.isDefault = true
      }
      if (this.isEdit || this.isTariffPlan) {
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_SERVICES']))
        for (let el of this.radiusAttrItems) {
          el.value = el.attr_value
          if (el.tag && (el.vendor === 0)) {
            el.value = ':' + el.tag + ':' + el.attr_value
          }
          switch (el.attr_type) {
            case 1:
              el.attrType = this.$i18n.t('Number')
              break
            case 2:
              el.attrType = this.$i18n.t('String')
              break
            case 3:
              el.attrType = 'IP'
              break
            case 4:
              el.attrType = this.$i18n.t('Binary')
              break
          }
        }
        if (!this.editItem.iptraffic_service_data.group2tf.length) {
          for (let curBorder of this.editItem.iptraffic_service_data.borders) {
            for (let curMap of curBorder.border_map) {
              curMap.tclass_id = curBorder.tclass_id
              this.borderItems.push(curMap)
            }
          }
        }
        if (this.editItem.iptraffic_service_data.group2tf.length === 0) {
          for (let i in this.editItem.iptraffic_service_data.prepaid) {
            if (this.editItem.iptraffic_service_data.prepaid[i].prepaid_unit) {
              this.prepaymentItems.push(this.editItem.iptraffic_service_data.prepaid[i])
            }
          }
          for (let i in this.editItem.iptraffic_service_data.prepaid_max) {
            for (let j in this.prepaymentItems) {
              if (this.editItem.iptraffic_service_data.prepaid_max[i].tclass_id === this.prepaymentItems[j].tclass_id) {
                this.prepaymentItems[j].prepaid_unitMax = this.editItem.iptraffic_service_data.prepaid_max[i].prepaid_unit
              }
            }
          }
          for (let el of this.prepaymentItems) {
            for (let elClasses of this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']) {
              if (el.tclass_id === elClasses.tclass_id) {
                el.tcclassName = elClasses.name + ' (' + elClasses.tclass_id + ')'
              }
            }
          }
        }
        if (this.editItem.iptraffic_service_data.group2tf.length) {
          this.selectGroup = this.editItem.iptraffic_service_data.group2tf[0].tariff_formula_type
        }
        for (let el of this.editItem.iptraffic_service_data.tclass_id2group) {
          this.groupItems.push(el)
        }
        for (let el of this.groupItems) {
          for (let elClasses of this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']) {
            if (el.tclass_id === elClasses.tclass_id) {
              el.tcclassName = elClasses.name + ' (' + elClasses.tclass_id + ')'
            }
          }
        }
        if (this.selectGroup === 2 && this.editItem.iptraffic_service_data.group2tf.length) {
          for (let i in this.editItem.iptraffic_service_data.borders) {
            for (let j in this.editItem.iptraffic_service_data.borders[i].border_map) {
              this.editItem.iptraffic_service_data.borders[i].border_map[j].tclass_id = this.editItem.iptraffic_service_data.borders[i].tclass_id
              this.borderItems.push(this.editItem.iptraffic_service_data.borders[i].border_map[j])
            }
          }
          for (let el of this.borderItems) {
            for (let elClasses of this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']) {
              if (el.tclass_id === elClasses.tclass_id) {
                el.tcclassName = elClasses.name + ' (' + elClasses.tclass_id + ')'
              }
            }
          }
        } else if (this.selectGroup === 1 && this.editItem.iptraffic_service_data.group2tf.length) {
          for (let i in this.editItem.iptraffic_service_data.borders) {
            for (let j in this.editItem.iptraffic_service_data.tclass_id2group) {
              if (this.editItem.iptraffic_service_data.borders[i].tclass_id === this.editItem.iptraffic_service_data.tclass_id2group[j].tclass_id) {
                this.maxGroup.push(this.editItem.iptraffic_service_data.borders[i])
              }
            }
          }
          for (let i in this.maxGroup[0].border_map) {
            this.maxGroup[0].border_map[i].tclass_id = 0
            this.maxGroup[0].border_map[i].tcclassName = this.maxGroupClass.tcclassName
            this.borderItems.push(this.maxGroup[0].border_map[i])
          }

          let borderItems = this.editItem.iptraffic_service_data.borders.filter((value) => {
            for (let curGroup of this.groupItems) {
              if (value.tclass_id === curGroup.tclass_id) {
                return false
              }
            }
            return true
          })
          for (let curBorder of borderItems) {
            for (let curMap of curBorder.border_map) {
              curMap.tclass_id = curBorder.tclass_id
              this.borderItems.push(curMap)
            }
          }
        }
        for (let el of this.borderItems) {
          for (let elClasses of this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']) {
            if (el.tclass_id === elClasses.tclass_id) {
              el.tcclassName = elClasses.name + ' (' + elClasses.tclass_id + ')'
            }
          }
        }
      } else {
        this.radiusAttrItems = []
      }
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.radItemForEdit = row
      this.rowRadiusAttr = JSON.parse(JSON.stringify(row.item))
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    editRadiusAttr (radAttr) {
      if (this.radItemForEdit.item) {
        this.radiusAttrItems[this.radItemForEdit.index] = radAttr
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      }
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    showAddBorder () {
      this.border = JSON.parse(JSON.stringify(this.emptyBorder))
      this.isEditBorder = false
      this.$refs.modalBorder.show()
    },
    ClickOnEditBorderButton (row) {
      this.border = row.item
      this.selectTrafficClasses = this.border.tclass_id
      this.isEditBorder = true
      this.$refs.modalBorder.show()
    },
    deleteBorder (row) {
      this.borderItems = this.borderItems.filter((value) => {
        return value !== row.item
      })
    },
    hideModalBorder () {
      this.$refs.modalBorder.hide()
    },
    saveBorder () {
      if (!this.border.cost) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error cost format'), 'Error')
        return
      }
      if (!this.border.border) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error border format'), 'Error')
        return
      }
      if (this.selectGroup === 1) {
        for (let i in this.groupItems) {
          if (this.groupItems[i].tclass_id === this.selectTrafficClasses) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This TClass is already used in max group'), 'Error')
            return
          }
        }
      }
      this.border.border = Number(this.border.border)
      this.border.cost = Number(this.border.cost)
      this.border.tclass_id = this.selectTrafficClasses
      for (let el of this.trafficClassesList) {
        if (el.value === this.border.tclass_id) {
          this.border.tcclassName = el.text
          break
        }
      }
      if (this.selectGroup === 1 && this.selectTrafficClasses === 0) {
        this.border.tcclassName = this.maxGroupClass.tcclassName
      }
      if (!this.isEditBorder) {
        this.borderItems.push(this.border)
      }
      this.hideModalBorder()
    },
    showAddPrepayment () {
      this.prepayment = JSON.parse(JSON.stringify(this.emptyPrepayment))
      this.isEditPrepayment = false
      this.$refs.modalPrepayment.show()
    },
    ClickOnEditPrepaymentButton (row) {
      this.prepayment = row.item
      this.isEditPrepayment = true
      this.$refs.modalPrepayment.show()
    },
    deletePrepayment (row) {
      this.prepaymentItems = this.prepaymentItems.filter((value) => {
        return value !== row.item
      })
    },
    hideModalPrepayment () {
      this.$refs.modalPrepayment.hide()
    },
    savePrepayment () {
      if (!this.prepayment.prepaid_unit) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error border format'), 'Error')
        return
      }
      if (!this.isEditPrepayment) {
        for (let i in this.prepaymentItems) {
          if (this.prepaymentItems[i].tclass_id === this.selectTrafficClasses) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt add one more prepaid traffic for tclass'), 'Error')
            return
          }
        }
      }
      this.prepayment.prepaid_unit = Number(this.prepayment.prepaid_unit)
      this.prepayment.prepaid_unitMax = Number(this.prepayment.prepaid_unitMax)
      this.prepayment.tclass_id = this.selectTrafficClasses
      for (let el of this.trafficClassesList) {
        if (el.value === this.prepayment.tclass_id) {
          this.prepayment.tcclassName = el.text
          break
        }
      }
      if (!this.isEditPrepayment) {
        this.prepaymentItems.push(this.prepayment)
      }
      this.hideModalPrepayment()
    },
    addTrafficClass () {
      for (let i in this.groupItems) {
        if (this.groupItems[i].tclass_id === this.selectTrafficClassesFprGroup) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt add one more prepaid traffic for tclass'), 'Error')
          return
        }
      }
      let newTrafficInGroup = {
        'tclass_id': 0,
        'group_id': 0,
        'tcclassName': ''
      }
      newTrafficInGroup.tclass_id = this.selectTrafficClassesFprGroup
      for (let el of this.trafficClassesList) {
        if (el.value === newTrafficInGroup.tclass_id) {
          newTrafficInGroup.tcclassName = el.text
          break
        }
      }
      this.groupItems.push(newTrafficInGroup)
    },
    deleteTrafficClass (row) {
      this.groupItems = this.groupItems.filter((value) => {
        return value !== row.item
      })
    }
  },
  computed: {
    borderItemsFiltered () {
      return this.borderItems.filter((value) => value.border || value.cost)
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TRAFFIC_CLASSES_LIST')
    this.$store.dispatch('Settings/GET_TUNNEL_ATTRIBUTES')
  },
  watch: {
    groupItems: function (val) {
      if (val.length > 0 && this.selectGroup === 1) {
        let maxGroupClass = this.trafficClassesList.find(el => {
          return el.value === 0
        })
        if (!maxGroupClass) {
          this.trafficClassesList.push(this.maxGroupClass)
        }
      } else {
        this.trafficClassesList = this.trafficClassesList.filter((value) => {
          return value.value !== 0
        })
        if (this.trafficClassesList.length > 0) {
          this.selectTrafficClasses = this.trafficClassesList[0].value
        }
      }
    },
    selectGroup: function (val) {
      if (this.selectGroup === 2) {
        this.trafficClassesList = this.trafficClassesList.filter((value) => {
          return value.value !== 0
        })
        if (this.trafficClassesList.length > 0) {
          this.selectTrafficClasses = this.trafficClassesList[0].value
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formIPtrafficService.vue